import React from "react";
import Image1 from "../assets/book_Knowledge.gif";
import { BiHome, BiVideoRecording } from "react-icons/bi";



const Congratulation = () => {
  return (
    <div className="flex items-center bg-white h-screen w-screen justify-center ">
      <div className="max-w-4xl flex items-center justify-center h-[90%]">
        <div className="flex flex-col justify-center h-full items-center ">
          <img
            className="left-Img w-[60%] rounded-3xl   object-cover "
            src={Image1}
            alt="Img"
          />
          <div className="flex items-center">
            <div className="flex flex-col gap-3 items-center justify-center">
              <h1 className="lg:text-6xl  text-4xl animate-bounce mt-4 font-semibold Bonheur text-violet-500">
                Congratulations <span className="animate-pulse">🎉</span>
              </h1>
              <p className="text-zinc-700 text-xl text-center mt-4 font-semibold">
              you got 40% scholarship for <br/> Regular classroom program at Resonance Indore
              </p>
              {/* <h1 className="mt-4 text-2xl font-semibold">
                To get the study material
              </h1> */}
              {/* <p className="text-3xl text-violet-500 font-semibold ">5 / 5</p>
              <h1 className="font-semibold">Question Correct</h1> */}
            </div>
            {/* <img className="rightImg size-52 mt-16" src={Image2} alt="Img2" /> */}
          </div>
          <a rel="noopener noreferrer" href="https://www.youtube.com/@ResonanceIndore-28Jan" target="_blank" ><div className="btn flex items-center justify-center gap-4">
            <button className="px-8 cursor-pointer mt-6 py-2 gap-2 flex items-center bg-violet-500 rounded-full text-white hover:bg-violet-700">
             <BiVideoRecording size={24}/> Youtube Videos
            </button>
            {/* <button className="px-8  cursor-pointer mt-6 py-2 gap-2  flex items-center bg-white border-2 rounded-full text-violet-700  hover:bg-violet-300">
              <BiBookContent size={24}/>Study Material
            </button> */}
          </div></a>
          <div onClick={()=>{window.location.replace("/")}} className="px-8 cursor-pointer mt-6 py-2 bg-white border-2 rounded-full text-violet-700  hover:bg-violet-300 flex gap-2 items-center">
            <BiHome className="m-0" size={16} />
            Back to Home
          </div>
        
          <div className=" bottom-0 left-0 w-full overflow-hidden leading-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="#f3f4f5"
                fill-opacity="1"
                d="M0,256L18.5,245.3C36.9,235,74,213,111,186.7C147.7,160,185,128,222,122.7C258.5,117,295,139,332,149.3C369.2,160,406,160,443,176C480,192,517,224,554,202.7C590.8,181,628,107,665,112C701.5,117,738,203,775,224C812.3,245,849,203,886,202.7C923.1,203,960,245,997,234.7C1033.8,224,1071,160,1108,128C1144.6,96,1182,96,1218,133.3C1255.4,171,1292,245,1329,256C1366.2,267,1403,213,1422,186.7L1440,160L1440,320L1421.5,320C1403.1,320,1366,320,1329,320C1292.3,320,1255,320,1218,320C1181.5,320,1145,320,1108,320C1070.8,320,1034,320,997,320C960,320,923,320,886,320C849.2,320,812,320,775,320C738.5,320,702,320,665,320C627.7,320,591,320,554,320C516.9,320,480,320,443,320C406.2,320,369,320,332,320C295.4,320,258,320,222,320C184.6,320,148,320,111,320C73.8,320,37,320,18,320L0,320Z"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Congratulation;
